export const Constants = {
	APOLLO_CLIENT_NUGGET_KMS_API_NAME: "nuggetKmsApi",
};
